import type { DeletionBlockReason, DeletionImpactNode } from '@vivport/backend/types';
import { ContentType } from '@vivport/backend/types';
import { getCollectionLabel, getContentTypeDisplayLabel } from '@/lib/content-labels';

// Written out per reason rather than printed from the enum: the member needs to know
// what to do next, which the enum name does not tell them. A Record means a new block
// reason on the backend fails the build here instead of rendering an empty row.
export const BLOCK_REASON_COPY: Record<DeletionBlockReason, string> = {
  PROVENANCE_APEX_HAS_CHILDREN:
    'This record is the audit trail for content that still exists. Delete or move that content first.',
  PROVENANCE_APEX_HAS_EXECUTIONS: 'Automated runs are still attributed to this record.',
  LIVING_DOCUMENT_TARGET: 'An automation maintains this document. Disable the automation first.',
  TEMPLATE_DEFINITION: 'A template is built from this. Delete the template first.',
  NO_DELETE_PERMISSION: 'You do not have permission to delete this.',
};

export function nodeTypeLabel(node: DeletionImpactNode): string {
  return node.contentType === ContentType.COLLECTION
    ? getCollectionLabel(node.collectionKind)
    : getContentTypeDisplayLabel(node.contentType);
}

export function nodeTitle(node: DeletionImpactNode): string {
  const trimmed = (node.title ?? '').trim();
  return trimmed.length > 0 ? trimmed : node.code;
}
